import { Box, BoxProps, ColorOptions, IconNew, TextProps } from '@jfs/ui-new'
import { useState } from 'react'
import { ListColumn } from '../ListColumn'

interface ListRowProps {
  item: any
  index: number
  sizeConfig: Array<number>
  headTitle: Array<any>
  onPress: () => void
  onEdit: (item?: any) => void
  onDelete: (item?: any) => void
  onAction?: () => void
  expandView?: any
  isExpanded: boolean
  expandedIndex: number
  showExpandArrow: boolean
  hrefPath?: string
  isActionLoading?: boolean
  loadingIndex?: number
  type: string
  onChecked?: (isChecked, index) => void
  columnsWidth?: any
  cellTextStyle?: TextProps
}

const ListRow = ({
  item,
  sizeConfig,
  headTitle,
  onPress,
  onEdit,
  onDelete,
  onAction,
  index,
  expandView,
  isExpanded,
  expandedIndex,
  showExpandArrow,
  hrefPath,
  isActionLoading,
  loadingIndex,
  type,
  onChecked,
  columnsWidth,
  cellTextStyle,
}: ListRowProps) => {
  const [hover, setHoverColor] = useState<{ isHovering: boolean; value: number }>({ isHovering: false, value: 0 })
  const keys = headTitle.map((elm) => {
    return Object.keys(elm)[0]
  })

  let lastId = 0

  return (
    <>
      <Box
        {...styles.container(item.status, type)}
        borderTopWidth={index === 0 ? 1 : 0}
        ph={showExpandArrow ? 0 : 'LARGE'}
        overflow={'hidden'}
        onHover={(isHover) => setHoverColor({ isHovering: isHover, value: index })}
        bg={hover.value === index && hover.isHovering ? 'GRAY_BORDER' : 'BRAND_PRIMARY_WHITE'}>
        {showExpandArrow && (
          <Box
            w={52}
            align={'center'}
            justify={'center'}
            h={54}
            marginRight={16}
            onPress={onPress}
            hoverColor={'#0000001f' as ColorOptions}
            underlayColor={'TRANSPARENT'}>
            <IconNew
              id={item?.id === expandedIndex ? 'ARROW_DOWN' : 'ARROW_RIGHT'}
              weight={'dense'}
              color={'#858796' as ColorOptions}
            />
          </Box>
        )}
        {Object.keys(item).map((data, id) => {
          if (keys.includes(data)) {
            const size = sizeConfig?.[lastId]
            lastId++
            return (
              <ListColumn
                columnIndex={id}
                size={size}
                type={data}
                label={item[data]}
                onAction={onAction}
                onPress={onPress}
                onEdit={onEdit}
                onDelete={onDelete}
                hrefPath={hrefPath}
                isActionLoading={isActionLoading}
                loadingIndex={loadingIndex}
                index={index}
                onChecked={onChecked}
                columnWidth={columnsWidth ? columnsWidth(data) : undefined}
                cellTextStyle={cellTextStyle}
              />
            )
          }
          return null
        })}
      </Box>
      {expandView && item?.id === expandedIndex && expandView()}
    </>
  )
}

const styles = {
  container: (status: string, type: string) =>
    ({
      bg: 'BRAND_PRIMARY_WHITE',
      direction: 'row',
      display: 'flex',
      align: 'center',
      borderBottomWidth: 1,
      borderLeftWidth: type === 'SCROLLABLE' ? 1 : 0,
      borderRightWidth: type === 'SCROLLABLE' ? 1 : 0,
      overflow: 'auto',
      borderColor: 'GRAY_BORDER',
      height: type === 'VPA' ? 48 : 55,
      underlayColor: 'GRAY_BORDER',
      opacity: status?.toLowerCase?.() === 'completed' ? 0.6 : 1,
    } as BoxProps),
}

export { ListRow }
